import React from "react";
import { BaseRate } from "./AdjFiles/BaseRate";
import { AdjDriverRate } from "./AdjFiles/AdjDriverRate";
import { SpecialRates } from "./AdjFiles/SpecialRates";
import { AdjFscRate } from "./AdjFiles/AdjFscRate";
import { AdjExmlRate } from "./AdjFiles/AdjExmlRate";
import { AdjLHIORate } from "./AdjFiles/AdjLHIORate";

export const Adjustments = ({ data }) => {
  const adj = _.get(data?.difference[0], "account_adjustments[0]", {});
  const source = _.isArray(adj) ? adj[0] : adj;
  const category =
  _.get(source, "new_value.category") ??
  _.get(source, "old_value.category") ??
  null;


  const renderSpecificAdj = (category) => {
    if (!category) return;
    switch (category) {
      case "BR":
      case "SMP":  
        return <BaseRate data={data} category={category} />;
      case "DVR":
        return <AdjDriverRate data={data} category={category} />;
      case "SPLD": 
      case "BA" :
        return <SpecialRates data={data} category={category} />;
      case "FSC":
        return <AdjFscRate data={data} category={category} />;
      case 'EXML':
        return <AdjExmlRate data={data} category={category} />   
      case 'LHIO':
        return <AdjLHIORate data={data} category={category} />   
    }
  };

  return <div>{renderSpecificAdj(category)}</div>;
};
